import React, { useEffect, useRef, useState } from "react";
import AuthContainer from "./AuthContainer";
import CoreOtpInput from "../../core/inputs/CoreOtpInput";
import CorePassword from "../../core/inputs/CorePassword";
import { Box, Card, CardContent, Container, Grid, Link } from "@mui/material";
import CoreButton from "../../core/inputs/CoreButton";
import { useDispatch, useSelector } from "react-redux";
import { setNextUrl, setRouteReducer } from "../../store/actions/routeActions";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  OTP_SENT_ERROR,
  OTP_SENT_SUCCESS,
} from "../../store/types/communicationTypes";
import { setCommunicationReducer } from "../../store/actions/communicationActions";
import { setAuthReducer } from "../../store/actions/authActions";
import { LOGIN_ERROR, LOGIN_SUCCESS } from "../../store/types/authTypes";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreTypographySubtitle2 from "../../core/dataDisplay/CoreTypographySubtitle2";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { Formik } from "formik";
import { loginWithMfaSchema } from "../../formSchemas/authSchemas";
import CoreCaptcha from "../../core/inputs/CoreCaptcha";
import { theme } from "../../config/theme";
import CoreTextButton from "../../core/inputs/CoreTextButton";
import { useNavigate } from "react-router";

export default function LoginWithOtp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const captchaRef = useRef();

  const uid = useSelector((state) => state?.auth?.tempUid);
  const authError = useSelector((state) => state?.auth?.authError);

  const onBack = () => {
    navigate("/login");
    dispatch(setAuthReducer({ verificationRequired: false, uid: null }));
    dispatch(setNextUrl("/login"));
  };

  const onLogin = (values, actions) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/verify/account",
        {
          userId: uid,
          otp: values.otp,
          captchaToken: values.captchaToken,
        },
        null,
        null,
        LOGIN_SUCCESS,
        LOGIN_ERROR,
        false,
        false,
      ),
    );
  };

  useEffect(() => {
    if (authError) {
      captchaRef?.current?.reset();
    }
  }, [authError]);

  return (
    <AuthContainer>
      <CoreH4
        style={{
          fontStyle: "italics",
          color: theme.palette.primary.main,
          alignSelf: "baseline",
        }}
      >
        Verify OTP
      </CoreH4>
      <form style={{ width: "100%" }}>
        <Formik
          initialValues={{
            otp: "",
            captchaToken: "",
          }}
          validationSchema={loginWithMfaSchema}
          onSubmit={onLogin}
        >
          {(formikProps) => (
            <>
              <CoreOtpInput
                id="otp"
                onBlur={formikProps.handleBlur("otp")}
                onChange={(value) => {
                  formikProps.setFieldValue("otp", value);
                }}
                value={formikProps.values.otp}
                formikProps={formikProps}
                autoFocus={true}
                label="Enter OTP"
              />
              <CoreCaptcha
                id="captchaToken"
                onChange={(val) => {
                  if (val) {
                    formikProps.setFieldValue("captchaToken", val);
                  }
                }}
                formikProps={formikProps}
                captchaRef={captchaRef}
              />
              <CoreButtonContainer>
                <CoreContainedButton
                  fullWidth={true}
                  type="submit"
                  onClick={formikProps.handleSubmit}
                >
                  Verify and Login
                </CoreContainedButton>
              </CoreButtonContainer>
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <CoreTextButton onClick={onBack}>Cancel</CoreTextButton>
              </Box>
            </>
          )}
        </Formik>
      </form>
    </AuthContainer>
  );
}
